import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal, Overline } from "../components/site/Reveal";
import { useLang } from "../context/LanguageContext";
import { sanitizeHtml } from "../lib/sanitize";
import api from "../lib/api";

export default function Terms() {
  const { lang, t } = useLang();
  const [terms, setTerms] = useState(null);

  useEffect(() => { api.get("/terms").then((r) => setTerms(r.data)).catch(() => setTerms({})); }, []);

  const title = terms?.[`title_${lang}`] || t("Terms of Use", "Conditions d'utilisation");
  const intro = terms?.[`intro_${lang}`] || "";
  const body = terms?.[`body_${lang}`] || "";

  return (
    <div data-testid="terms-page" className="max-w-3xl mx-auto px-5 md:px-8 pb-24">
      <Reveal><Overline>{t("Legal", "Légal")}</Overline></Reveal>
      <Reveal delay={0.1}><h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium text-primary tracking-tight mt-3">{title}</h1></Reveal>
      {intro && <Reveal delay={0.15}><p className="text-foreground/70 mt-4">{intro}</p></Reveal>}
      <Reveal delay={0.2}>
        <div className="prose-article mt-10 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-primary [&_h2]:mt-8 [&_p]:text-foreground/75 [&_p]:leading-relaxed [&_p]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_a]:text-secondary"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(body) }} />
      </Reveal>
      <p className="text-sm text-muted-foreground mt-10">{t("Questions?", "Des questions ?")} <Link to="/contact" className="text-secondary font-semibold hover:underline">{t("Contact us", "Contactez-nous")}</Link>.</p>
    </div>
  );
}
